import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/opt/build/repo/middleware/redirects.global.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "app-check": () => import("/opt/build/repo/middleware/appCheck.js"),
  "nav-guard": () => import("/opt/build/repo/middleware/navGuard.js")
}